import React from "react";
import AdSenseBanner from "../components/AdSenseBanner";
// Ajuste/retire se não estiver usando anúncios

function Faq() {
  return (
    <div
      className="container"
      style={{ paddingTop: "80px", paddingBottom: "40px" }}
    >
      <h2 className="mb-4">Perguntas Frequentes (FAQ)</h2>
      {/* Exemplo de anúncio do AdSense */}
      <AdSenseBanner />
      <div className="accordion" id="faqAccordion">
        {/* FAQ Item 1 */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="faq1">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="false"
              aria-controls="collapseOne"
            >
              Quais riscos e cuidados devo ter antes de alterar o ETACS?
            </button>
          </h2>
          <div
            id="collapseOne"
            className="accordion-collapse collapse"
            aria-labelledby="faq1"
            data-bs-parent="#faqAccordion"
          >
            <div className="accordion-body">
              Toda alteração na central ETACS deve ser feita com cautela. É
              fundamental fazer backup dos arquivos originais (Variant e Custom)
              antes de qualquer modificação. As instruções fornecidas são fruto
              de pesquisas de entusiastas, portanto você assume a
              responsabilidade pelas alterações. Em caso de erro, apenas a
              concessionária ou um software de fábrica poderá recuperar sua
              ETACS, caso você não tenha backups.
            </div>
          </div>
        </div>

        {/* FAQ Item 2 */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="faq2">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              Qual interface OBD2 devo usar para acessar a ETACS?
            </button>
          </h2>
          <div
            id="collapseTwo"
            className="accordion-collapse collapse"
            aria-labelledby="faq2"
            data-bs-parent="#faqAccordion"
          >
            <div className="accordion-body">
              São recomendadas duas opções principais:
              <ul>
                <li>
                  <strong>ELM327 v1.5 (chip PIC18F25k80)</strong> – versão
                  genuína, que normalmente funciona melhor.
                </li>
                <li>
                  <strong>Cabo mini VCI J2534</strong> – usado também em
                  veículos Toyota e compatível com ETACS.
                </li>
              </ul>
              Versões falsas (ex. ELM327 v2.1) podem falhar. Sempre verifique se
              o seu ELM327 é original.
            </div>
          </div>
        </div>

        {/* FAQ Item 3 */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="faq3">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              Por que preciso salvar o arquivo Variant e Custom antes de mudar
              algo?
            </button>
          </h2>
          <div
            id="collapseThree"
            className="accordion-collapse collapse"
            aria-labelledby="faq3"
            data-bs-parent="#faqAccordion"
          >
            <div className="accordion-body">
              O backup dos arquivos <em>Variants</em> e <em>Custom</em> é a
              única forma de reverter o estado original da sua central ETACS
              caso algo saia errado. Se não fizer backup, e o veículo apresentar
              problemas, a restauração pode exigir equipamento de fábrica ou
              assistência especializada.
            </div>
          </div>
        </div>

        {/* FAQ Item 4 */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="faq4">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFour"
              aria-expanded="false"
              aria-controls="collapseFour"
            >
              Não consigo conectar o MMCodingWriter. O que posso fazer?
            </button>
          </h2>
          <div
            id="collapseFour"
            className="accordion-collapse collapse"
            aria-labelledby="faq4"
            data-bs-parent="#faqAccordion"
          >
            <div className="accordion-body">
              Se houver falha ao conectar, tente:
              <ul>
                <li>
                  Desconectar o ELM327, desligar a ignição, reconectar e ligar a
                  ignição novamente.
                </li>
                <li>
                  Verificar se a <strong>Porta COM</strong> e a velocidade
                  (38400 bps) estão configuradas corretamente.
                </li>
                <li>
                  Desativar antivírus ou firewall que possa bloquear o
                  MMCodingWriter.
                </li>
                <li>
                  Tentar algumas vezes, pois algumas interfaces podem falhar na
                  primeira tentativa.
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* FAQ Item 5 */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="faq5">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFive"
              aria-expanded="false"
              aria-controls="collapseFive"
            >
              Não grava as alterações no MMCodingWriter. O que devo verificar?
            </button>
          </h2>
          <div
            id="collapseFive"
            className="accordion-collapse collapse"
            aria-labelledby="faq5"
            data-bs-parent="#faqAccordion"
          >
            <div className="accordion-body">
              Caso as alterações não sejam salvas na central ETACS:
              <ul>
                <li>
                  Certifique-se de que a opção <strong>“Write Bypass”</strong>{" "}
                  esteja marcada em Settings.
                </li>
                <li>
                  Desmarque módulos que não estiver usando (Engine, ABS etc.) e
                  deixe apenas ETACS marcado.
                </li>
                <li>
                  Garanta que a bateria do carro não esteja fraca, pois
                  oscilações podem interromper o processo de gravação.
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* FAQ Item 6 */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="faq6">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseSix"
              aria-expanded="false"
              aria-controls="collapseSix"
            >
              O carro não aceita uma função (por ex., rebatimento do
              retrovisor). O que significa?
            </button>
          </h2>
          <div
            id="collapseSix"
            className="accordion-collapse collapse"
            aria-labelledby="faq6"
            data-bs-parent="#faqAccordion"
          >
            <div className="accordion-body">
              Nem todos os modelos/versões do veículo suportam as mesmas
              funcionalidades. Por exemplo, se seu carro não tem motor de
              rebatimento nos retrovisores, ativar essa opção não trará efeito.
              Certas funções requerem hardware específico ou chicotes
              conectados.
            </div>
          </div>
        </div>

        {/* FAQ Item 7 */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="faq7">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseSeven"
              aria-expanded="false"
              aria-controls="collapseSeven"
            >
              Se ocorrerem alarmes ou falhas após a modificação, como proceder?
            </button>
          </h2>
          <div
            id="collapseSeven"
            className="accordion-collapse collapse"
            aria-labelledby="faq7"
            data-bs-parent="#faqAccordion"
          >
            <div className="accordion-body">
              Utilize o MMCodingWriter na aba “DTC” para ler/apagar códigos de
              falha. Se o problema persistir, tente restaurar o backup original
              ou consulte um especialista. Em alguns casos, pode ser necessário
              equipamento de fábrica ou assistência na concessionária.
            </div>
          </div>
        </div>
      </div>{" "}
      {/* accordion end */}
    </div>
  );
}

export default Faq;
